import { render, staticRenderFns } from "./RecetasView.vue?vue&type=template&id=eb60e612"
import script from "./RecetasView.vue?vue&type=script&lang=js"
export * from "./RecetasView.vue?vue&type=script&lang=js"
import style0 from "./RecetasView.vue?vue&type=style&index=0&id=eb60e612&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports